export default "__VITE_ASSET__CcLZb1mR__"